export default __webpack_public_path__ + "static/media/B-box_1.4e382c14.svg";